import React from "react";
import { ReactController } from "./react_controller";
import { GregPrimerTheme } from "@getregistered/greg-editors";
import { DownloadTray } from "../components/DownloadTray";

export class DownloadTrayController extends ReactController {
  connect() {
    this.root.render(
      <GregPrimerTheme>
        <DownloadTray {...this.propsValue} />
      </GregPrimerTheme>
    );
  }
}

